<template>
  <div class="sign">
    <van-tabs
      type="card"
      color="#ffffff"
      background="#aaaaaa"
      title-inactive-color="#000000"
      title-active-color="#000000"
      sticky
      @click="tabsClick"
    >
      <van-tab title="SKU"></van-tab>
      <van-tab title="货柜"></van-tab>
    </van-tabs>

    <div class="sign-search">
      <div class="btn-box">
        <van-field
          size="small"
          v-model="search.skuCode"
          placeholder="请扫码SKU"
          right-icon="scan"
          clearable
          clear-trigger="always"
          :formatter="relationNumberFmt"
          @click-right-icon="scanSku"
          @keyup.13="getList()"
          @input="getList"
          @keyup="inputNum"
          ref="scanInp"
        />

        <van-field
          size="small"
          v-model="search.containerNo"
          placeholder="输入货柜号"
          clearable
          clear-trigger="always"
          :formatter="relationNumberFmt"
          v-if="tabType != 'sku'"
          @keyup.13="getList()"
          @input="getList"
        />
      </div>
      <div
        class="toSearch-box"
        :style="{ 'min-height': tabType === 'sku' ? '55px' : '90px' }"
      >
        <button
          class="sign-toSearch"
          :style="{
            height: tabType === 'sku' ? '40%' : '65%',
            'min-height': tabType === 'sku' ? '36px' : '80px',
          }"
          @click="getList()"
        >
          查询
        </button>
      </div>
    </div>

    <div class="sign-item">
      <template v-if="startSearch">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </template>
      <template v-else>
        <template v-if="list.length">
          <ul class="bale-sku" v-if="tabType === 'sku'">
            <li
              @click="toDetail('/mobile/pickingDetail', item, 1)"
              v-for="(item, index) in list"
              :key="index"
            >
              <div>
                <div class="sign-list">
                  <p>SKU：{{ item.skuCode }}</p>
                  <p>发货编码：{{ item.sourceNo }}</p>
                </div>
                <div class="sign-list">
                  <p>货柜号：{{ item.containerNo }}</p>
                </div>
                <div class="sign-list">
                  <p>拣货进度：{{ item.pickQty }}/{{ item.quantity }}</p>
                  <p>创建时间：{{ item.createTimeDesc }}</p>
                </div>
              </div>
            </li>
          </ul>

          <ul class="bale-container" v-else>
            <li>
              <div>货柜号</div>
              <div>拣货进度</div>
              <div>创建时间</div>
            </li>
            <li
              @click="toDetail('/mobile/pickingContainer', item, 2)"
              v-for="(item, index) in list"
              :key="index"
            >
              <div>{{ item.containerNo }}</div>
              <div>{{ item.pickQty }}/{{ item.quantity }}</div>
              <div style="white-space: nowrap">{{ item.createTimeDesc }}</div>
            </li>
          </ul>
        </template>
        <template v-else>
          <van-empty image="search" description="暂无数据" />
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
} from "vant";
import {
  GetWaitPickInfoBySku,
  GetWaitPickInfoByContainerNo,
} from "@/api/mobile/picking_api";
import { mapState, mapMutations } from "vuex";
import util from "util/date";
import { debounce } from "util/util";
import { mixins } from "../mobileMixins";

export default {
  data() {
    return {
      search: {
        skuCode: "",
        transportType: "海运",
        containerNo: "",
        WarehouseId: 0,
      },
      list: [],
      startSearch: false,
      tabType: "sku",
    };
  },

  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Field.name]: Field,
  },

  mixins: [mixins],

  created() {
    this.init();
  },

  computed: {
    ...mapState({ warehouse: (state) => state.common.warehouse }),
  },

  mounted() {},

  methods: {
    ...mapMutations({
      saveMobileTitle: "saveMobileTitle",
    }),
    init() {
      const _warehouse = window.localStorage.warehouse
        ? JSON.parse(window.localStorage.warehouse)
        : this.warehouse;
      // this.$set(this.search, 'warehouseId', _warehouse.warehouseId)

      this.saveMobileTitle(`拣货(${this.$route.query.type})`);
      this.search.transportType = this.$route.query.type;

      this.getList();
    },
    scanSku() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.$set(that.search, "skuCode", a.resultStr);
          that.getList();
        },
      });
    },
    getList() {
      this.startSearch = true;
      this.tabType === "sku" ? this.getForSku() : this.getForContainer();
    },

    getForSku() {
      this.list = [];
      const obj = this.search;
      delete obj.containerNo;
      const _warehouse = JSON.parse(window.localStorage.warehouse);
      this.search.WarehouseId = _warehouse.warehouseId;

      GetWaitPickInfoBySku(obj).then((res) => {
        this.startSearch = false;
        if (res.status === 200 && res.success) {
          const { response } = res;

          if (!response.length) Toast("暂无匹配数据");

          this.list = response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    getForContainer() {
      this.list2 = [];
      const _warehouse = JSON.parse(window.localStorage.warehouse);
      this.search.WarehouseId = _warehouse.warehouseId;
      GetWaitPickInfoByContainerNo(this.search).then((res) => {
        this.startSearch = false;
        if (res.status === 200 && res.success) {
          const { response } = res;

          if (!response.length) Toast("暂无匹配数据");

          this.list = response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    toDetail(url, item, type) {
      let obj = {};
      if (type === 1) {
        const {
          shippingPlanDetailID,
          shippingPlanID,
          skuCode,
          productID,
          stockingTaskID,
        } = item;
        obj = {
          shippingPlanDetailID,
          shippingPlanID,
          skuCode,
          productID,
          stockingTaskID,
        };
      } else {
        const { containerNo, stockingTaskID } = item;
        obj = { containerNo, stockingTaskID };
      }
      this.$router.push({ path: url, query: obj });
      // this.$router.push({ path: url })
    },

    relationNumberFmt(v) {
      return v.trim();
    },

    tabsClick(n, t) {
      this.tabType = n === 0 ? "sku" : "container";
      this.getList();
    },

    tabsFinishClick(n, t) {},
  },

  watch: {
    $route: async function (newValue, from) {
      this.$nextTick(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";

.sign-search .toSearch-box {
  flex: 0.4;
  margin-left: 3%;
  min-height: 90px;
}

.sign-toSearch {
  width: 100%;
  height: 65%;
  min-height: 80px;
  border-radius: 5px;
  border: 0;
  color: #fff;
  font-size: 20px;
}

::v-deep .van-tabs__nav--card {
  margin: 0;
  border: 0;
}

.sign-item .bale-container li {
  display: flex;
  height: 40px;
  line-height: 40px;
  & > div {
    flex: 1;
    text-align: center;
  }
}
</style>